import React, { useEffect, useState } from "react";
import { TextField, Button, Grid, Autocomplete, Box } from "@mui/material";
import { EyeIcon } from "../../../Componants/Common/CustomEyeIcon";
import {
  createClientOrganization,
  dropdownSubscription,
  fetchSubscriptionList,
  getOrganizations,
  updateOrganization,
  singleImageUpload
} from "../../../API Service/apiService";
import { Calendar } from "../../../Componants/Common/Calender";

import toast, { Toaster } from "react-hot-toast";
import Loader from "../../../Componants/Loader/Loader";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import { formatDateForPayload, parseDateInput, validateDateRange } from "../../../utils/dateFormatter";
import { useLocation, useHistory, useNavigate } from "react-router-dom";
import { Constants } from "../../../constants/Constants";
const subscriptionTypes = ["trial", "subscription"];

// import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
// import SuperAdminTabs from "../../../Componants/Common/SuperAdminTabs";

const inventoryManagementOpt = ["Yes", "No"];

const commonSX = {
  width: {
    xs: "100%", // Full width on extra-small screens
    sm: "75%", // 75% width on small screens
    md: "60%", // 60% width on medium screens
    lg: "70%", // 50% width on large screens
  },
};

const CreateOrganizations = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const [orgID, setOrgID] = useState(queryParams.get("orgID"));
  const [editIndex, setEditIndex] = useState(false);
  const [organizationData, setOrganizationData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]); // State for subscription plans
  const [showPassword, setShowPassword] = useState(false);

  const showPasswordVisibility = () => {
    setShowPassword(true);
  };
  const hidePasswordVisibility = () => {
    setShowPassword(false);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const [formData, setFormData] = useState({
    clientName: "",
    companyName: "",
    mobileNo: "",
    email: "",
    alternateNo: "",
    address: "",
    subscriptionType: "",
    startDate: null,
    endDate: null,
    subscriptionPlan: null,
    noOfLicense: "",
    planPrice: "",
    accessKey: "",
    loginID: "",
    password: "",
    canManageInventory: "",
    image: null,
    inentoryManagement: "",
  });
  const [imageValue, setImageValue] = useState([]);
  const [errors, setErrors] = useState({});

  const fetchSubscriptionPlans = async () => {
    try {
      const response = await fetchSubscriptionList();
      console.log(response);
      if (response) {
        setSubscriptionPlans(response);
      }
    } catch (error) {
      console.error("Failed to fetch subscription plans:", error);
    }
  };

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    let newError = "";

    if (name === "clientName" || name === "companyName" || name === "address" || name === "loginID" || name === "accessKey") {
      value = value.slice(0, 50); // Enforce max length 50
      if (value.length > 0 && value.length < 3) {
        newError = `${name} must be at least 3 characters`;
      }
    }

    if (name === "mobileNo" || name === "alternateNo" || name === "noOfLicense" || name === "planPrice") {
      value = value.replace(/\D/g, ""); // Allow only numeric characters
      value = value.slice(0, 10); // Restrict to max 10 digits
    }

    if (name === "email") {
      if (value.length > 0 && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        newError = "Valid Email is required";
      }
    }

    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prev) => ({ ...prev, [name]: newError }));
  };

  // Generic handler for updating form fields
  const handleDateChange = (fieldName, value) => {
    const formattedDate = formatDateForPayload(value);
    setFormData((prevState) => {
      const updatedData = {
        ...prevState,
        [fieldName]: formattedDate,
      };

      // Instant validation for dates using common function
      if (fieldName === "startDate" || fieldName === "endDate") {
        const validation = validateDateRange(updatedData.startDate, updatedData.endDate);
        setErrors((prev) => ({
          ...prev,
          endDate: validation.error,
        }));
      }
      return updatedData;
    });

    setErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };

  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      image: e.target.files[0],
    });
    setImageValue([]);
    setErrors((prev) => ({ ...prev, image: "" }));
  };

  const handleSubscriptionTypeChange = (event, newValue) => {
    setFormData({
      ...formData,
      subscriptionType: newValue,
    });
    setErrors((prev) => ({ ...prev, subscriptionType: "" }));
  };

  const handleSubscriptionPlanChange = (event, newValue) => {
    setFormData({
      ...formData,
      subscriptionPlan: newValue ? newValue._id : null, // Store plan ID
    });
    setErrors((prev) => ({ ...prev, subscriptionPlan: "" }));
  };

  const handleInventoryManagementChange = (event, newValue) => {
    setFormData({
      ...formData,
      canManageInventory: newValue === "Yes",
    });
    setErrors((prev) => ({ ...prev, canManageInventory: "" }));
  };

  // const handleSubmit = async () => {
  //   try {
  //     setLoading(true);
  //     const formDataToSend = new FormData();
  //     const payload = {
  //       ...formData,
  //       startDate: formData.startDate
  //         ? new Date(formData.startDate).toISOString()
  //         : null,
  //       endDate: formData.endDate
  //         ? new Date(formData.endDate).toISOString()
  //         : null,
  //     };

  //     // Append all fields to FormData
  //     Object.keys(formData).forEach((key) => {
  //       if (formData[key] !== null && formData[key] !== undefined) {
  //         if (key === "image") {
  //           // Append file only if it exists
  //           if (formData.image) {
  //             formDataToSend.append("image", formData.image);
  //           }
  //         } else {
  //           formDataToSend.append(key, formData[key]);
  //         }
  //       }
  //     });

  //     // Convert dates to ISO strings before sending
  //     if (formData.startDate) {
  //       formDataToSend.set(
  //         "startDate",
  //         new Date(formData.startDate).toISOString()
  //       );
  //     }
  //     if (formData.endDate) {
  //       formDataToSend.set("endDate", new Date(formData.endDate).toISOString());
  //     }

  //     // Send API request
  //     const response = await createClientOrganization(formDataToSend);
  //     console.log("API Response:", response);
  //     toast(response.message || "Organization Created Successfully!");
  //   } catch (error) {
  //     console.error("Error creating organization:", error);
  //     toast("Failed to create organization. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  // const handleSubmit = async () => {
  //   try {
  //     setLoading(true);
  //     let imagePath = [];

  //     // First upload the image if it exists
  //     if (formData.image && imageValue.length === 0) {
  //       const imageFormData = new FormData();
  //       imageFormData.append('imageType', 'organization');
  //       imageFormData.append('image', formData.image);

  //       const imageResponse = await singleImageUpload(imageFormData);
  //       if (imageResponse && imageResponse.data.data.fullPath) {
  //         imagePath = imageResponse.data.data.fullPath;
  //         setImageValue(imagePath);
  //       }
  //     }

  //     const formDataToSend = new FormData();

  //     // Append all fields to FormData
  //     Object.keys(formData).forEach((key) => {
  //       if (formData[key] !== null && formData[key] !== undefined) {
  //         if (key === 'image') {
  //           // Use the image path from singleImageUpload instead of the file
  //           if (imagePath.length > 0) {
  //             formDataToSend.append('imagePath', imagePath.length > 0 ? imagePath : imageValue);
  //           }
  //         } else {
  //           formDataToSend.append(key, formData[key]);
  //         }
  //       }
  //     });

  //     // Convert dates to ISO strings before sending
  //     if (formData.startDate) {
  //       formDataToSend.set('startDate', new Date(formData.startDate).toISOString());
  //     }
  //     if (formData.endDate) {
  //       formDataToSend.set('endDate', new Date(formData.endDate).toISOString());
  //     }

  //     // Send API request to create organization
  //     const response = await createClientOrganization(formDataToSend);
  //     console.log("API Response:", response);
  //     toast(response.message || "Organization Created Successfully!");
  //   } catch (error) {
  //     console.error("Error creating organization:", error);
  //     toast.error("Failed to create organization. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.clientName) {
      newErrors.clientName = "Client Name is required";
    } else if (formData.clientName.length < 3) {
      newErrors.clientName = "Client Name must be at least 3 characters";
    }

    if (!formData.companyName) {
      newErrors.companyName = "Company Name is required";
    } else if (formData.companyName.length < 3) {
      newErrors.companyName = "Company Name must be at least 3 characters";
    }

    if (!formData.loginID) {
      newErrors.loginID = "Login ID is required";
    } else if (formData.loginID.length < 3) {
      newErrors.loginID = "Login ID must be at least 3 characters";
    }

    if (!formData.accessKey) {
      newErrors.accessKey = "Access Key is required";
    } else if (formData.accessKey.length < 3) {
      newErrors.accessKey = "Access Key must be at least 3 characters";
    }

    if (!formData.address) {
      newErrors.address = "Address is required";
    } else if (formData.address.length < 3) {
      newErrors.address = "Address must be at least 3 characters";
    }


    if (!formData.mobileNo) {
      newErrors.mobileNo = "Mobile No. is required";
    } else if (!/^\d{10}$/.test(formData.mobileNo)) {
      newErrors.mobileNo = "Valid 10-digit Mobile No. is required";
    }
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
      newErrors.email = "Valid Email is required";
    }
    if (!formData.subscriptionType) newErrors.subscriptionType = "Subscription Type is required";
    if (!formData.startDate) newErrors.startDate = "Start Date is required";
    if (!formData.password && !editIndex) newErrors.password = "Password is required";
    if (formData.canManageInventory === "") newErrors.canManageInventory = "Inventory Mgmt is required";
    if (!formData.image && !editIndex) newErrors.image = "Image is required";
    if (formData.subscriptionType === "subscription") {
      if (!formData.endDate) {
      newErrors.endDate = "End Date is required";
    } else {
      const validation = validateDateRange(formData.startDate, formData.endDate);
      if (!validation.isValid) {
        newErrors.endDate = validation.error;
      }
    }
      if (!formData.subscriptionPlan) newErrors.subscriptionPlan = "Plan is required";
      if (!formData.noOfLicense) newErrors.noOfLicense = "No. of Licenses is required";
      if (!formData.planPrice) newErrors.planPrice = "Price is required";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      // toast.error("Please fill all the required fields.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      let imagePath = '';
      // First upload the image if it exists
      if (formData.image && imageValue.length === 0) {
        const imageFormData = new FormData();
        imageFormData.append('imageType', 'organization');
        imageFormData.append('image', formData.image);

        const imageResponse = await singleImageUpload(imageFormData);
        if (imageResponse.data.status === "success" && imageResponse.data.data.fullPath) {
          imagePath = imageResponse.data.data.fullPath;
          setImageValue(imagePath);
        }
        else {
          toast.error("Failed to upload image");
          return;
        }
      }


      // Prepare payload for organization creation
      const payload = {
        clientName: formData.clientName,
        companyName: formData.companyName,
        mobileNo: formData.mobileNo,
        email: formData.email,
        alternateNo: formData.alternateNo,
        address: formData.address,
        subscriptionType: formData.subscriptionType,
        startDate: formatDateForPayload(formData.startDate, null),
        endDate: formatDateForPayload(formData.endDate, null),
        subscriptionPlan: formData.subscriptionPlan,
        noOfLicense: formData.noOfLicense,
        planPrice: formData.planPrice,
        accessKey: formData.accessKey,
        loginID: formData.loginID,
        password: formData.password,
        canManageInventory: formData.canManageInventory,
        imagePath: imagePath.length > 0 ? imagePath : imageValue
      };

      // Send API request to create organization
      const response = await createClientOrganization(payload);
      toast.success(response.message || "Organization Created Successfully!");

      // Optional: Clear form or redirect after success
      handleCancel();
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "An error occurred";
      toast.error(errorMessage);
      console.error("Error creating organization:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      clientName: "",
      companyName: "",
      mobileNo: "",
      email: "",
      alternateNo: "",
      address: "",
      subscriptionType: "",
      startDate: null,
      endDate: null,
      subscriptionPlan: null,
      noOfLicense: "",
      planPrice: "",
      accessKey: "",
      loginID: "",
      password: "",
      canManageInventory: "",
      image: null,
    });
    setEditIndex(false);
    setOrgID(null); // Clear state
    setSubscriptionPlans([]);
    setErrors({});

    navigate(location.pathname, { replace: true });
  };

  const handleEdit = async () => {
    try {
      setEditIndex(true);
      const params = { organizationId: orgID };
      const orgData = await getOrganizations(params);
      console.log("Organization Data:", orgData);
      if (orgData) {
        const org = orgData.data.organizations[0];
        console.log(org);
        setFormData({
          clientName: org.clientName || "",
          companyName: org.companyName || "",
          mobileNo: org.mobileNo || "",
          email: org.email || "",
          alternateNo: org.alternateNo || "",
          address: org.address || "",
          subscriptionType: org.subscriptionType || "trial",
          startDate: formatDateForPayload(org.subscriptionType === "subscription" ? org.subscriptionStartDate : org.trialStartDate),
          endDate: formatDateForPayload(org.subscriptionType === "subscription" ? org.subscriptionEndDate : org.trialEndDate),
          subscriptionPlan: org.subscriptionPlan || null,
          noOfLicense: org.noOfLicense || "",
          planPrice: org.planPricePerUser || "",
          accessKey: org.accessKey || "",
          loginID: org.loginID || "",
          password: org.password || "",
          canManageInventory: org.canManageInventory || false,
          image: null,
        });
        setImageValue(org.imagePath || []);
      }
    } catch (error) {
      console.error("Error in handleEdit:", error);
      toast.error("Failed to load organization data for editing.");
    }
  };

  const handleUpdate = async () => {
    if (!validateForm()) return;
    try {
      setLoading(true);
      let imagePath = '';
      // First upload the image if it exists and imageValue is empty (meaning a new file was chosen)
      if (formData.image && imageValue.length === 0) {
        const imageFormData = new FormData();
        imageFormData.append('imageType', 'organization');
        imageFormData.append('image', formData.image);

        const imageResponse = await singleImageUpload(imageFormData);
        if (imageResponse.data.status === "success" && imageResponse.data.data.fullPath) {
          imagePath = imageResponse.data.data.fullPath;
          setImageValue(imagePath);
        }
        else {
          toast.error("Failed to upload image");
          return;
        }
      }

      // Prepare body for organization update
      const body = {
        clientName: formData.clientName,
        companyName: formData.companyName,
        mobileNo: formData.mobileNo,
        email: formData.email,
        alternateNo: formData.alternateNo,
        address: formData.address,
        subscriptionType: formData.subscriptionType,
        startDate: formatDateForPayload(formData.startDate, null),
        endDate: formatDateForPayload(formData.endDate, null),
        subscriptionPlan: formData.subscriptionPlan,
        noOfLicense: formData.noOfLicense,
        planPrice: formData.planPrice,
        accessKey: formData.accessKey,
        loginID: formData.loginID,
        password: formData.password,
        canManageInventory: formData.canManageInventory,
        imagePath: imagePath.length > 0 ? imagePath : imageValue,
        organizationId: orgID,
      };

      const response = await updateOrganization(body);
      toast.success(response.message || "Organization Updated Successfully!");
      handleCancel();
      setTimeout(() => {
        navigate('/createorganizationsview');
      }, 1000);
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "An error occurred";
      toast.error(errorMessage);
      console.error("Error updating organization:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orgID) {
      handleEdit();
    }
  }, [orgID]);
  useEffect(() => {
    fetchSubscriptionPlans();
  }, []);

  return (
    <>
      <HeaderNavigation value={"Create Client/Organization"} />
      <Box
        classname="ClientOrganization-container"
        sx={{
          padding: "30px",
          backgroundColor: "#eff3fe",
          margin: "5px",
          borderRadius: "10px",
          paddingBottom: "30px",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Client Name *"
              name="clientName"
              value={formData.clientName}
              onChange={handleInputChange}
              error={!!errors.clientName}
              helperText={errors.clientName}
              sx={commonSX}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Company Name *"
              name="companyName"
              value={formData.companyName}
              onChange={handleInputChange}
              error={!!errors.companyName}
              helperText={errors.companyName}
              sx={commonSX}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Mobile No. *"
              name="mobileNo"
              value={formData.mobileNo}
              onChange={handleInputChange}
              error={!!errors.mobileNo}
              helperText={errors.mobileNo}
              sx={commonSX}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Email *"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              error={!!errors.email}
              helperText={errors.email}
              sx={commonSX}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Alternate No."
              name="alternateNo"
              value={formData.alternateNo}
              onChange={handleInputChange}
              sx={commonSX}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Address *"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              error={!!errors.address}
              helperText={errors.address}
              sx={commonSX}
            />
          </Grid>

          {/* Subscription Type */}
          <Grid item xs={6} md={4}>
            <Autocomplete
              sx={commonSX}
              options={subscriptionTypes}
              value={formData.subscriptionType}
              onChange={handleSubscriptionTypeChange}
              // disabled={editIndex}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Subscription Type *"
                  variant="standard"
                  error={!!errors.subscriptionType}
                  helperText={errors.subscriptionType}
                />
              )}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <Calendar
              value={parseDateInput(formData.startDate)}
              handleChange={handleDateChange}
              fieldName="startDate"
              label="Select Start Date *"
              error={!!errors.startDate}
              helperText={errors.startDate}
              withPortal={true}
              sx={commonSX}
              minDate={new Date()}
              // readOnly={editIndex}
            />
          </Grid>

          {/* Conditionally Rendered Fields */}
          {formData.subscriptionType === "subscription" && (
            <>
              <Grid item xs={6} md={4}>
                <Calendar
                  value={parseDateInput(formData.endDate)}
                  handleChange={handleDateChange}
                  fieldName="endDate"
                  label="Select End Date *"
                  error={!!errors.endDate}
                  helperText={errors.endDate}
                  withPortal={true}
                  sx={commonSX}
                  minDate={parseDateInput(formData.startDate) || new Date()}
                  // readOnly={editIndex}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <Autocomplete
                  sx={{
                    width: {
                      xs: "100%",
                      sm: "75%",
                      md: "60%",
                      lg: "50%",
                    },
                  }}
                  options={subscriptionPlans}
                  getOptionLabel={(option) => option.packageName}
                  value={
                    subscriptionPlans.find(
                      (plan) => plan._id === formData.subscriptionPlan
                    ) || null
                  }
                  onChange={handleSubscriptionPlanChange}
                  // disabled={editIndex}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Subscription Plan *"
                      variant="standard"
                      error={!!errors.subscriptionPlan}
                      helperText={errors.subscriptionPlan}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  variant="standard"
                  label="No. of Licenses *"
                  name="noOfLicense"
                  value={formData.noOfLicense}
                  onChange={handleInputChange}
                  error={!!errors.noOfLicense}
                  helperText={errors.noOfLicense}
                  sx={commonSX}
                />
              </Grid>

              <Grid item xs={6} md={4}>
                <TextField
                  variant="standard"
                  label="Plan Price Per User *"
                  name="planPrice"
                  value={formData.planPrice}
                  onChange={handleInputChange}
                  error={!!errors.planPrice}
                  helperText={errors.planPrice}
                  sx={commonSX}
                />
              </Grid>
            </>
          )}

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Access Key *"
              name="accessKey"
              value={formData.accessKey}
              onChange={handleInputChange}
              error={!!errors.accessKey}
              helperText={errors.accessKey}
              sx={commonSX}
            />
          </Grid>

          <Grid item xs={6} md={4}>
            <TextField
              variant="standard"
              label="Login ID *"
              name="loginID"
              value={formData.loginID}
              onChange={handleInputChange}
              error={!!errors.loginID}
              helperText={errors.loginID}
              sx={commonSX}
            />
          </Grid>
       
          {!editIndex && (
            <Grid item xs={6} md={4} sx={{ display: "flex", alignItems: "end" }}>
              <TextField
                variant="standard"
                label="Password *"
                name="password"
                type={showPassword ? "text" : "password"}
                value={formData.password}
                onChange={handleInputChange}
                error={!!errors.password}
                helperText={errors.password}
                sx={commonSX}
              />
              <EyeIcon
                showPassword={showPassword}
                showPasswordVisibility={showPasswordVisibility}
                hidePasswordVisibility={hidePasswordVisibility}
              />
            </Grid>
          )}

          <Grid item xs={6} md={4}>
            <Autocomplete
              sx={{
                width: {
                  xs: "100%",
                  sm: "75%",
                  md: "60%",
                  lg: "50%",
                },
              }}
              options={inventoryManagementOpt}
              value={formData.canManageInventory ? "Yes" : "No"}
              onChange={handleInventoryManagementChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Inventory Management *"
                  variant="standard"
                  error={!!errors.canManageInventory}
                  helperText={errors.canManageInventory}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <div className="textinput-ClientOrganization">
              <input
                style={{ border: 0, paddingTop: "20px" }}
                type="file"
                onChange={handleFileChange}
              />
            </div>
            {errors.image && (
              <span style={{ color: "#d32f2f", fontSize: "0.75rem", fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', marginLeft: "14px", marginTop: "3px", display: "block" }}>
                {errors.image}
              </span>
            )}
          </Grid>

          <Grid item xs={12} style={{ textAlign: "right" }}>
            <Button
              variant="contained"
              className="action-button"
              size="large"
              style={{ backgroundColor: "#32499F", color: "white" }}
              // onClick={handleSubmit}
              onClick={editIndex ? handleUpdate : handleSubmit}
            >
              {!editIndex ? Constants.create : Constants.update}
            </Button>
            <Button
              variant="contained"
              className="action-button"
              size="large"
              style={{
                backgroundColor: "#32499F",
                color: "white",
                marginLeft: "10px",
              }}
              onClick={handleCancel}
            >
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Toaster />
      {loading && <Loader />}
    </>
  );
};

export default CreateOrganizations;
